import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import {setSubAspekEdit} from "../actions"
import { doGet, doPost,doPut } from "../services/api-service";
import { useSelector,useDispatch } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import Select from "react-select";
import Delete from "@material-ui/icons/Delete";
import SwapVert from "@material-ui/icons/SwapVert";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";

import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import DebouncedTextField from "../components/DebouncedTextField";
import Widgets from "@material-ui/icons/Widgets";
import NativeSelect from "@material-ui/core/NativeSelect";
import Remove from "@material-ui/icons/Remove";
import Add from "@material-ui/icons/Add";


const PaSubAspekCreateComponent = props => {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user.user)
    const [selectedunsurCode, setSelectedunsurCode] = useState("")
    const subaspek_to_edit = useSelector(state => state.assessment.subaspek_to_edit)    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [status, setStatus] = useState(true);
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [aspek, setAspek] = useState(null);
    const [subAspek, setsubAspek] = useState(null);
    const [aspekOption, setAspekOption] = useState([]);
    const [unsurs, setUnsurs] = useState([]);
    const { classes } = props;

    useEffect(() => {
        getAspekOption();
    }, []);

    useEffect(() => {
        if(subaspek_to_edit){
            getSubAspekDetail(subaspek_to_edit)
        }
    }, [subaspek_to_edit])

    const getAspekOption = async () => {
        const params={is_active:1};
        const response = await doGet("pa/aspek", params);
        if (response&&response.data&&response.data.length > 0) {
            const dataForSelect = response.data.map(aspek => ({
                value: aspek.id,
                label: `${aspek.code} - ${aspek.name}`
            }));
            setAspekOption(dataForSelect);
        }
    };

    const getSubAspekDetail = async (subAspek) => {
        const params = {};
        const response = await doGet("pa/subaspek/"+subAspek.id, params);
        if(response && response.data){
            const subAspek = response.data
            setCode(subAspek.code)
            setName(subAspek.name)
            let aspek = {
                label:subAspek.aspek_code+" - "+subAspek.aspek_name, 
                value:subAspek.aspek_id
            }            
            setAspek(aspek)
            setsubAspek(subAspek)
            setUnsurs(
                subAspek.unsurs.map(uns=>(
                    {
                        sub_aspek_code:subAspek.code,
                        unsur_code:uns.code,
                        unsur_name:uns.name,
                        order:uns.id,
                        showCategory:false,
                        external_data:uns.external_data,
                        is_optional:uns.is_optional===1,
                        receiver_unsur_code:uns.receiver_unsur_code,
                        category_0_label:uns.category_0_label,
                        category_1_label:uns.category_1_label,
                        category_2_label:uns.category_2_label,
                        category_3_label:uns.category_3_label,
                        category_4_label:uns.category_4_label}
                ))
                )
        }            
    }


    const submit = async() => {
        if(!subaspek_to_edit){
            create();
        }else{
            await edit()
            dispatch(setSubAspekEdit())
        }
        props.history.goBack();
    };

    const edit =async ()=>{
        const params = {
            id:subaspek_to_edit.id,
            aspek_id: aspek?aspek.value:null,
            code: code,
            name: name, 
            status: status == true ? 1 : 0,
            updated_by: user.emp_id
        };
        await doPut("pa/subaspek", params, "save aspek");
    }

    const create = async () => {

        if (aspek !== null) {
            const params = {
                aspek_id: aspek?aspek.value:null,
                code: code,
                name: name,
                status: status == true ? 1 : 0,
                creator: user.emp_id
            };
            await doPost("pa/subaspek", params, "save sub aspek");
        }
    };

    const cancel = () => {
        props.history.goBack();
    };
    const statusChange = e => {
        setStatus(!status);
    };
    const codeChange = e => {
        setCode(e.target.value);
    };
    const nameChange = e => {
        setName(e.target.value);
    };

    const aspekChange = e => {
        setAspek(e);
    };

    const unsurNameChange = (value,unsur_code) => {
        let newUnsur = unsurs.filter(unsur=>unsur.unsur_code === unsur_code)[0]
        newUnsur = {...newUnsur, unsur_name: value}

        const otherUnsurs = unsurs.filter(unsur=>unsur.unsur_code !== unsur_code)
        const sorted = [...otherUnsurs, newUnsur].sort((a, b) => (a.order > b.order) ? 1 : -1)
        setUnsurs(sorted)
    };

    const deleteUnsur = (unsur_code,sub_code) => {
        let index=1;
        const deletedUnsur = unsurs.filter(u=>u.unsur_code!==unsur_code)

        const tobeReplaceUnsur = deletedUnsur.filter(u=>u.sub_aspek_code===sub_code)
        const otherUnsur = deletedUnsur.filter(u=>u.sub_aspek_code!==sub_code)

        const replacedUnsur = tobeReplaceUnsur.map(u2=>{
                                return {...u2, unsur_code:`${sub_code}.${index}`, order:index++}
                            })
        setUnsurs([...otherUnsur,...replacedUnsur])
    };

    const OpenCloseCategory = ({open, unsur_code})=> {
        if(open){
            return (<Tooltip title="Hide score categories">
                        <IconButton aria-label="ExpandLess Score Categories" onClick={()=>toggleScoreLabel(unsur_code)}>
                            <ExpandLess/>
                        </IconButton>
                    </Tooltip>)
        }

        return (<Tooltip title="Show score categories">
                        <IconButton aria-label="ExpandMore" onClick={()=>toggleScoreLabel(unsur_code)}>
                            <ExpandMore/>
                        </IconButton>
                    </Tooltip>)
    }

    const toggleScoreLabel = (unsur_code) => {
        let selectedUnsur = unsurs.filter(u=>u.unsur_code===unsur_code)[0]
        const otherUnsurs = unsurs.filter(u=>u.unsur_code!==unsur_code)

        selectedUnsur= {...selectedUnsur, showCategory:!selectedUnsur.showCategory}

        const sorted = [...otherUnsurs, selectedUnsur].sort((a, b) => (a.order > b.order) ? 1 : -1)
        setUnsurs(sorted)
    };

    const toggleExternalDataMenu = (unsurCode,event) => {
        if(anchorEl)
        setAnchorEl(null);
        else
        setAnchorEl(event.currentTarget);
        setSelectedunsurCode(unsurCode)
      };

    const handleSelectBobotReceiver = (unsur_code,event) => {
        let newUnsur = unsurs.find(unsur=>unsur.unsur_code === unsur_code)
        newUnsur = {...newUnsur, receiver_unsur_code: event.target.value}

        const otherUnsurs = unsurs.filter(unsur=>unsur.unsur_code !== unsur_code)
        const sorted = [...otherUnsurs, newUnsur].sort((a, b) => (a.order > b.order) ? 1 : -1)
        setUnsurs(sorted)
    };


    const categoryLabelChange = (value,unsur_code,score) => {
        let selectedUnsur = unsurs.filter(u=>u.unsur_code===unsur_code)[0]
        const otherUnsurs = unsurs.filter(u=>u.unsur_code!==unsur_code)

        switch(score){
            case 0:
                selectedUnsur= {...selectedUnsur, category_0_label:value}
            break;
            case 1:
                selectedUnsur= {...selectedUnsur, category_1_label:value}
            break;
            case 2:
                selectedUnsur= {...selectedUnsur, category_2_label:value}
            break;
            case 3:
                selectedUnsur= {...selectedUnsur, category_3_label:value}
            break;
            case 4:
                selectedUnsur= {...selectedUnsur, category_4_label:value}
            break;
        }


        const sorted = [...otherUnsurs, selectedUnsur].sort((a, b) => (a.order > b.order) ? 1 : -1)
        setUnsurs(sorted)
    }


    const setThisCategoriesForAllUnsur = (unsur_code) => {
        let selectedUnsur = unsurs.filter(u=>u.unsur_code===unsur_code)[0]

        let UnsursSameSubaspek = unsurs.filter(u=>u.sub_aspek_code===selectedUnsur.sub_aspek_code)

        let UnsursOtherSubaspek = unsurs.filter(u=>u.sub_aspek_code!==selectedUnsur.sub_aspek_code)

        const newUnsurs = UnsursSameSubaspek.map(unsur=>({...unsur,
                                        category_0_label:selectedUnsur.category_0_label,
                                        category_1_label:selectedUnsur.category_1_label,
                                        category_2_label:selectedUnsur.category_2_label,
                                        category_3_label:selectedUnsur.category_3_label,
                                        category_4_label:selectedUnsur.category_4_label}))

        const sorted = [...UnsursOtherSubaspek, ...newUnsurs].sort((a, b) => (a.order > b.order) ? 1 : -1)
        setUnsurs(sorted)

    }


    const title = subaspek_to_edit ? "Edit Sub Aspek" : "Create New Sub Aspek"
    return (
        <Grid container direction="column">
            <Grid item xs={6} container>
                <Grid item xs={12}>
                    <Typography
                        variant="h6"
                        gutterBottom
                        className="animated slideInLeft"
                    >
                        {title}
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <Select
                        isClearable={true}
                        value={aspek}
                        options={aspekOption}
                        onChange={aspekChange}
                        placeholder="Select Aspek"
                        styles={selectCustomZindex}
                    />
                </Grid>
                <Grid container>
                    <TextField
                        id="Code"
                        label="Code"
                        value={code}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        onChange={codeChange}
                    />
                </Grid>
                <Grid container>
                    <TextField
                        id="Name"
                        label="Name"
                        value={name}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        onChange={nameChange}
                    />
                </Grid>
                <Grid container>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={status}
                                onChange={statusChange}
                                color="primary"
                                inputProps={{
                                    "aria-label": "primary checkbox"
                                }}
                            />
                        }
                        label={status ? "active" : "inactive"}
                    />
                </Grid>
            </Grid>

            <Grid container className={classes.unsur_container}>
                {
                    unsurs.map(unsur=>(
                        <Grid item xs={12} container spacing={8} className={classes.unsur_row}>
                            <Grid item xs={2}>
                                <TextField
                                    id="Unsur Code"
                                    label="Unsur Code"
                                    value={unsur.unsur_code}
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                    style={{backgroundColor:"white", borderRadius:4}}
                                />

                            </Grid>
                            <Grid item xs={6}>
                                <DebouncedTextField
                                    id="Unsur Name"
                                    label="Unsur Name"
                                    key_id_1={unsur.unsur_code}
                                    value={unsur.unsur_name}
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                    onChange={unsurNameChange}
                                    style={{backgroundColor:"white", borderRadius:4}}
                                    multiline
                                    rows={6}
                                />
                            </Grid>

                            <Grid item xs={4} container alignItems="center">
                                {unsur.external_data}
                                
                                <OpenCloseCategory open={unsur.showCategory} unsur_code={unsur.unsur_code}/>

                                {

                                    unsur.is_optional &&
                                    <>
                                    <Typography type="body2" className={classes.pointer}>optional</Typography>
                                    
                                    <NativeSelect
                                    value={unsur.receiver_unsur_code}
                                    onChange={()=>{}}
                                    inputProps={{
                                        name: "age",
                                        id: "age-native-helper",
                                    }}
                                    style={{marginLeft: 8}}
                                    >
                                    <option value="">bobot receiver</option>
                                    {
                                        unsurs.map(fltUnsur=>(
                                        <option value={fltUnsur.unsur_code}>{fltUnsur.unsur_code}</option>
                                        ))
                                    }

                                    </NativeSelect>
                                    </>
                                }


                            </Grid>
                            {   unsur.showCategory &&
                                <Grid container className={classes.category_container}>
                                    <Grid item xs={12} container spacing={8} className={classes.category_row}>                                        
                                        <Grid item className={classes.category_field}>
                                            <DebouncedTextField
                                                    id="score4"
                                                    label="scored 4 means"
                                                    value={unsur.category_4_label}
                                                    key_id_1={unsur.unsur_code}
                                                    key_id_2={4}
                                                    margin="dense"
                                                    placeholder="meaning if the score is 4"
                                                    variant="outlined"
                                                    fullWidth
                                                    onChange={categoryLabelChange}
                                                    style={{backgroundColor:"white", borderRadius:4}}
                                                />
                                        </Grid>
                                        <Grid item className={classes.category_field}>
                                            <DebouncedTextField
                                                id="score3"
                                                label="scored 3 means"
                                                value={unsur.category_3_label}
                                                key_id_1={unsur.unsur_code}
                                                key_id_2={3}
                                                placeholder="meaning if the score is 3"
                                                margin="dense"
                                                variant="outlined"
                                                fullWidth
                                                onChange={categoryLabelChange}
                                                style={{backgroundColor:"white", borderRadius:4}}
                                            />
                                        </Grid>
                                        <Grid item className={classes.category_field}>
                                            <DebouncedTextField
                                                id="score2"
                                                label="scored 2 means"
                                                value={unsur.category_2_label}
                                                key_id_1={unsur.unsur_code}
                                                key_id_2={2}
                                                placeholder="meaning if the score is 2"
                                                margin="dense"
                                                variant="outlined"
                                                fullWidth
                                                onChange={categoryLabelChange}
                                                style={{backgroundColor:"white", borderRadius:4}}
                                            />
                                        </Grid>
                                        <Grid item className={classes.category_field}>
                                            <DebouncedTextField
                                                id="score1"
                                                label="scored 1 means"
                                                value={unsur.category_1_label}
                                                key_id_1={unsur.unsur_code}
                                                key_id_2={1}
                                                placeholder="meaning if the score is 1"
                                                margin="dense"
                                                variant="outlined"
                                                fullWidth
                                                onChange={categoryLabelChange}
                                                style={{backgroundColor:"white", borderRadius:4}}
                                            />
                                        </Grid>
                                        <Grid item className={classes.category_field}>
                                            <DebouncedTextField
                                                id="score0"
                                                label="scored 0 means"
                                                value={unsur.category_0_label}
                                                key_id_1={unsur.unsur_code}
                                                key_id_2={0}
                                                placeholder="meaning if the score is 0"
                                                margin="dense"
                                                variant="outlined"
                                                fullWidth
                                                onChange={categoryLabelChange}
                                                style={{backgroundColor:"white", borderRadius:4}}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>
                            }


                        </Grid>
                    ))
                }
                </Grid>


            <Grid
                justify="flex-end"
                container
                className={classes.marginTops}
                spacing={8}
            >
                <Grid item>
                    <Button variant="outlined" onClick={cancel}>
                        cancel
                    </Button>
                </Grid>

                <Grid item>
                    <Button
                        onClick={submit}
                        color="primary"
                        variant="contained"
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

const styles = theme => ({
    marginTops: {
        marginTop: 5
    },
    container: {
        marginTop: -16,
        marginLeft: 5
    },
    marginOver: {
        marginTop: -25
    },
    score: {
        maxWidth: 50
    },
    unsur_row:{
        padding:"0 0px 15px 10px",
        backgroundColor:"#e4ffe4",
        borderRadius:4
    },
    category_container:{
        marginLeft:15,
    }
});

export const selectCustomZindex = {
    control: (base, state) => ({
        ...base,
        minWidth: "150px",
        margin: "0 4px"
    }),
    container: (base, state) => {
        return {
            ...base,
            flex: 1,
            zIndex: state.isFocused ? "1100" : "1" //Only when current state focused
        };
    }
};


export default withRouter(withStyles(styles)(PaSubAspekCreateComponent));
